import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import $ from "jquery";
import {
  Paper,
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  Divider,
  Zoom,
  Collapse,
} from "@material-ui/core";
import React, { Component } from "react";
import { formateDate, getQueryVariable } from "../utils/utilTools";
import Pagination from "@material-ui/lab/Pagination";
import {
  VideoLibrary,
  InsertLink,
  ExpandLess,
  ExpandMore,
} from "@material-ui/icons";
import SearchNoResult from "./search-noResult";
import PagepreDis from "./pagepre-dis";
import Pagenext from "./pagenext";
import Pagepre from "./pagepre";
import PagenextDis from "./pagenext-dis";

require("../assets/css/style.css");
require("../assets/css/news-style.css");
require("../assets/css/kb-style.css");
const imageAccount = require("../assets/images/top-ico1.png");
const searchTitle = require("../assets/images/gw.png");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
    },
  },
  inputText: {
    padding: "0 5px 0 0",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

class SearchNews extends Component {
  constructor(props) {
    super();
    this.state = {
      selectedDate: new Date(),
      checked: false,
      collapseCheck: [],
    };
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return;
    };
  };
  componentWillReceiveProps(prop) {
    this.setState({
      checked: prop.results && prop.results.length > 0,
    });
  }

  componentDidMount() {
    let arr = [];
    for (let index = 0; index < 10; index++) {
      arr[index] = false;
    }
    this.setState({
      collapseCheck: arr,
    });
  }

  componentDidCatch(error, errorInfo) {
    console.log("==============", error, errorInfo);
  }

  setchecked = (index) => {
    let arr = this.state.collapseCheck;
    for (let i = 0; i < 10; i++) {
      if (index === i) {
        arr[i] = !this.state.collapseCheck[i];
      } else {
        arr[i] = false;
      }
    }
    this.setState({
      collapseCheck: arr,
    });
  };

  render() {
    const _state = this.state;
    const { setHotInfo, pageNum, handlePaging, pages, results, showLoading } =
      this.props;

    const loading = <div className="loader"> </div>;

    let contents = [];
    contents =
      results && results.length > 0 ? (
        results.map((value, index) => (
          // <Zoom
          //   in={_state.checked}
          //   style={{ transformOrigin: "0 0 0" }}
          //   {...(_state.checked > 0 ? { timeout: index * 200 } : {})}
          // >
          <Collapse
            in={this.state.collapseCheck[index]}
            timeout="auto"
            collapsedHeight={80}
          >
            <Card className="kb-content-card" key={index}>
              <CardContent
                className="kb-content-card-class"
                style={
                  this.state.collapseCheck[index]
                    ? { backgroundColor: "rgb(250 250 250)" }
                    : {}
                }
              >
                <div class="draw-kb" onClick={() => this.setchecked(index)}>
                  {value.catalogname ? (
                    <span className="tag">{value.catalogname}</span>
                  ) : (
                    ""
                  )}
                  <Typography
                    variant="h2"
                    component="h2"
                    style={{ lineHeight: "0" }}
                  >
                    <Link
                      // onClick={this.setHotInfo.bind(this)}
                      className="search-result-kb-title"
                      title={value.title}
                      target="_blank"
                      variant="body2"
                      dangerouslySetInnerHTML={{
                        __html: value.titleN ? value.titleN : value.title,
                      }}
                    ></Link>
                    &emsp;
                    {!value.catalogname ? (
                      ""
                    ) : value.catalogname.indexOf("视频") >= 0 ? (
                      <div className="title-icon">
                        <VideoLibrary style={{ color: "#f0b755" }} />
                      </div>
                    ) : value.catalogname.indexOf("国务院") >= 0 ||
                      value.catalogname.indexOf("江苏") >= 0 ? (
                      <div className="title-icon">
                        <InsertLink style={{ color: "#f0b755" }} />
                      </div>
                    ) : (
                      ""
                    )}
                    {/* &emsp;
                <span className="date-class">
                  发布时间：{formateDate(value.showtime)}
                </span> */}
                  </Typography>
                  <Typography component="p">
                    <div>
                      <p className="date-class">
                        发布时间：{formateDate(value.showtime)}
                      </p>
                      <Link
                        style={{ marginLeft: "10px" }}
                        className="date-class"
                        onClick={() => {
                          window.open(value.url);
                          setHotInfo(value.url, value.title);
                        }}
                        title={value.title}
                        target="_blank"
                        variant="body2"
                      >
                        查看详情
                      </Link>
                    </div>
                  </Typography>
                  {this.state.collapseCheck[index] ? (
                    <ExpandLess className="expand-class" />
                  ) : (
                    <ExpandMore className="expand-class" />
                  )}
                  <Divider />
                </div>
                <Typography
                  component="p"
                  dangerouslySetInnerHTML={{
                    __html: value.da ? value.da : "无",
                  }}
                ></Typography>
                <Divider />
              </CardContent>
            </Card>
          </Collapse>
          // </Zoom>
        ))
      ) : (
        <div className="content-class" style={{ textAlign: "center" }}>
          <SearchNoResult />
        </div>
      );

    //   <div className="content-class" style={{ textAlign: "center" }}>
    //   <SearchNoResult />
    // </div>

    return (
      <Grid container spacing={1}>
        {/* <Grid className="news-icon-class" item xs={1}>
          <img src={require("../assets/images/newsicon.png")} style={{width: "35px"}}/>
        </Grid> */}
        {/* <Grid className="news-title-p" item xs={11}>
          <p className="news-title">新闻动态</p>
          <div className="bottom-border"></div>
        </Grid> */}
        <Grid item xs={12}>
          {showLoading ? (
            loading
          ) : (
            <div>
              <Paper elevation={0}>
                <div className="news-list">{contents}</div>
              </Paper>
              {contents.length > 0 ? (
                // <div className="page-class">
                //   <div
                //     onClick={pageNum === 1 ? "" : () => handlePaging(true)}
                //     style={{ display: "inline-block" }}
                //   >
                //     {pageNum === 1 ? <PagepreDis /> : <Pagepre classname="page-news-back"/>}
                //   </div>
                //   <div
                //     onClick={pageNum === pages ? "" : () => handlePaging(false)}
                //     style={{ display: "inline-block" }}
                //   >
                //     {pageNum === pages ? <PagenextDis /> : <Pagenext classname="page-news-back"/>}
                //   </div>
                // </div>
                <Pagination
                  className="page-class"
                  size="medium"
                  shape="rounded"
                  count={pages}
                  page={pageNum}
                  onChange={handlePaging}
                />
              ) : (
                ""
              )}
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(SearchNews);
